// Form field wrapper: label (properly associated), the input, and an inline
// error message with aria wiring. Forms previously showed only a red border
// with no message and no screen-reader signal.
//
//   <Field id="phone" label={t('apply.phone')} required error={errors.phone?.message}>
//     <input id="phone" className="input-field" {...register('phone', {...})} />
//   </Field>
//
// The child input must carry the same id and (when errored) aria-invalid.
export default function Field({ id, label, required, error, hint, children, className = '' }) {
  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="label">
          {label} {required && <span className="text-primary-600" aria-hidden="true">*</span>}
        </label>
      )}
      {children}
      {hint && !error && <p className="mt-1 text-sm text-gray-500">{hint}</p>}
      {error && (
        <p id={`${id}-error`} className="mt-1 text-sm text-red-600" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
